import { useMutation, useQuery, useQueryClient } from "@tanstack/vue-query";
import APIClient, { type UserProperties } from "@/APIClient";
import { QueryKey } from "./query-keys";
import UserState from "../UserState";

export const useGetUsers = (organizationOnly = false) => {
  return useQuery({
    queryKey: [QueryKey.USERS, { organization: organizationOnly }],
    queryFn: async (): Promise<UserProperties[]> => {
      let res = await APIClient.fetchAllUsers();
      if (!organizationOnly) return res;

      const myOrganizationId = UserState.data?.organization?.id;
      if (!myOrganizationId) return [];

      res = res.filter((user) => user.organization?.id === myOrganizationId);

      res.sort((a, b) => a.id - b.id);
      return res;
    },
  });
};

export const useToggleUser = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({
      id,
      organizationId,
    }: {
      id: number;
      organizationId?: number;
    }) => {
      return await APIClient.toggleUser(id, organizationId);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QueryKey.USERS] });
    },
  });
};

export const useDeleteUser = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({
      id,
      organizationId,
    }: {
      id: number;
      organizationId?: number;
    }) => {
      await APIClient.deleteUser(id, organizationId);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QueryKey.USERS] });
    },
  });
};
